import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import '@trumedianetworks/tmn-core-components/src/tmn-checkbox';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';

class FormElementCheckbox extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                }
                tmn-checkbox {
                    width: fit-content;
                }
                .unchecked {
                    color: rgba(0, 0, 0, 0.1);
                }
            `,
        ];
    }

    render() {
        const { value } = this;
        const displayLabel = this.getDisplayLabel();
        if (this.isViewMode()) {
            return html`<div>
                <tmn-form-group row>
                    <label>
                        ${value
                            ? html`<tmn-icon icon="check_circle_outline"></tmn-icon>`
                            : html`<tmn-icon
                                  class="unchecked"
                                  icon="circle"
                                  iconvariant="outlined"></tmn-icon>`}
                    </label>
                    ${displayLabel}
                </tmn-form-group>
            </div>`;
        }
        return html`<tmn-checkbox
            label=${displayLabel}
            .checked=${value}
            @tmn-switch-change=${this.handleCheckboxChanged}
            >${displayLabel}
        </tmn-checkbox> `;
    }
    //<span class="tmn-icon-placeholder"></span>
    handleCheckboxChanged(e) {
        const { checked } = e.detail;
        const { path } = this;
        this.actions.setStagedEditByPath(path, checked);
    }
}
customElements.define('form-element-checkbox', FormElementCheckbox);
